import NestedFileDownloadLink from '@components/ag-grid-helpers/NestedFileDownloadLink'
import { agPriceCol, agStartDateCol } from '@/ag-grid/ag-columns'
import { notAnyValueCheck } from '@/ag-grid/utils/notAnyValue'
import * as apiTo from '@/modular-api'

export const gridOptions = {
  computed: {
    gridOptions() {
      return {
        columnDefs: [
          {
            headerName: 'File',
            cellRendererParams: params => {
              return {
                value: params.data
              }
            },
            cellRendererFramework: NestedFileDownloadLink
          },

          agStartDateCol({
            headerName: 'Issued on',
            field: 'issue_date',
            editable: true,
            cellClass: ['editable-cell'],
            cellEditorFramework: 'DateEditor'
          }),

          agStartDateCol({
            headerName: 'Due on',
            field: 'due_date',
            editable: true,
            cellClass: ['editable-cell'],
            cellEditorFramework: 'DateEditor'
          }),

          {
            headerName: 'Approved by',
            field: 'approved_by',
            editable: true,
            cellClass: ['editable-cell'],
            cellRenderer: notAnyValueCheck,
            cellEditorFramework: 'TextEditor'
          },

          agStartDateCol({
            headerName: 'Approved on',
            field: 'approval_date',
            editable: true,
            cellClass: ['editable-cell'],
            cellEditorFramework: 'DateEditor'
          }),

          {
            headerName: 'Paid by',
            field: 'paid_by',
            editable: true,
            cellClass: ['editable-cell'],
            cellRenderer: notAnyValueCheck,
            cellEditorFramework: 'TextEditor'
          },

          agStartDateCol({
            headerName: 'Paid on',
            field: 'payment_date',
            editable: true,
            cellClass: ['editable-cell'],
            cellEditorFramework: 'DateEditor'
          }),

          agPriceCol('Amount', 'amount', {
            editable: true,
            cellClass: ['editable-cell', 'ag-right-aligned-cell']
          }),

          {
            headerName: 'Payment ref',
            field: 'payment_reference',
            editable: true,
            cellClass: ['editable-cell'],
            cellRenderer: notAnyValueCheck,
            cellEditorFramework: 'TextEditor'
          },

          {
            headerName: 'Actions',
            cellRendererFramework: 'ActionsCol',
            cellRendererParams: params => ({
              popupActions: [{ name: 'delete', label: 'Delete', textColorClass: 'text-danger-1' }],
              onPopupAction: () => {
                apiTo
                  .DELETE_ENTITY_ADDITIONAL_ORDER('subscriptions', this.$route.params.id, params.data.id)
                  .then(() => {
                    this.data = this.data.filter(data => data.id !== params.data.id)
                  })
              }
            })
          }
        ],
        defaultColDef: {
          resizable: false,
          floatingFilter: false
        },
        domLayout: 'autoHeight'
      }
    }
  }
}
